import React from 'react';
import { Clock, Search, Lightbulb } from 'lucide-react';
import { motion } from 'framer-motion';

const Methodology: React.FC = () => {

  const steps = [
    {
      icon: Clock,
      title: 'Escuta',
      description: 'Primeiro, escuto sua história com atenção. Entendo o contexto, os fatos e suas preocupações para mapear a situação.'
    },
    {
      icon: Search,
      title: 'Análise',
      description: 'Analiso seu caso sob a perspectiva jurídica, identificando direitos, prazos e as melhores estratégias de atuação.'
    },
    {
      icon: Lightbulb,
      title: 'Estratégia',
      description: 'Desenvolvo um plano de ação personalizado, explicando as opções disponíveis e os caminhos mais adequados para seu caso.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="metodologia" className="section bg-white">
      <div className="wrapper">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-heading text-brand-slate mb-6">
            Como funciona?
          </motion.h2>
          <motion.p variants={itemVariants} className="text-lg text-brand-ink/90 max-w-3xl mx-auto">
            Minha abordagem é baseada em três pilares fundamentais que garantem um atendimento completo e personalizado.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <motion.div key={step.title} variants={itemVariants}>
                <div className="feature text-center h-full flex flex-col">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-xl bg-gradient-to-r from-brand-accent to-brand-slate flex items-center justify-center text-brand-sand shadow-soft">
                    <IconComponent size={32} />
                  </div>
                  <h3 className="text-xl font-semibold text-brand-slate mb-4">
                    {step.title}
                  </h3>
                  <p className="text-brand-ink/80 leading-relaxed flex-grow">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Methodology;